import type { ScenarioModel } from '@/shared/generated'
import type { OptimizationGroupMap } from '../model/types'

import { entries, groupBy, map, orderBy, pipe } from 'lodash/fp'

/**
 * Enriches scenarios with optimization group names and sorts them alphabetically.
 * @param optimizationGroupMap - Map of group IDs to their metadata (including name). [OptimizationGroupMap]
 * @param data - List of raw scenarios from the API. [ScenarioModel[]]
 * @returns Sorted list of scenarios with an added `optimization_group_name` field. [GroupedScenario[]]
 */

export const getGroupedScenarios = (
	optimizationGroupMap: OptimizationGroupMap | undefined
) =>
	pipe(
		groupBy('optimization_group_id'),
		entries,
		map(([groupId, scenarios]) => ({
			id: groupId,
			name: optimizationGroupMap?.[groupId]?.name || groupId,
			scenarios: orderBy(['is_main'], ['desc'])(scenarios as ScenarioModel[]),
		}))
	)
